import LayoutWarningsModal from './LayoutWarningsModal';

export default LayoutWarningsModal;
